/** How a guest operates a load. Decides which control component is rendered. */
export const CONTROL_KIND = {
  /** On or off. */
  TOGGLE: 'toggle',
  /** On or off plus a 0–100 level. */
  LEVEL: 'level',
  /**
   * A motor: open, close or stop. The DIN modules in use report no absolute
   * position, so this control offers directions rather than a position.
   */
  POSITION: 'position',
} as const;

export type ControlKind = (typeof CONTROL_KIND)[keyof typeof CONTROL_KIND];
